const pendingMacroRecordingVideoKeys = new Map<string, string>();

/**
 * Upper bound on outstanding upload video keys. A reply may never arrive (the
 * upload can fail at the transport layer), so the map must not grow without
 * limit — the oldest pending entry is evicted once the cap is reached.
 */
export const MAX_PENDING_MACRO_RECORDING_VIDEO_KEYS = 100;

/** Registers the API-minted video key when an upload command is forwarded to host-electron. */
export function registerMacroRecordingUploadVideoKey(requestId: string, videoKey: string): void {
  if (pendingMacroRecordingVideoKeys.size >= MAX_PENDING_MACRO_RECORDING_VIDEO_KEYS) {
    const oldest = pendingMacroRecordingVideoKeys.keys().next().value;
    if (oldest !== undefined) {
      pendingMacroRecordingVideoKeys.delete(oldest);
    }
  }
  pendingMacroRecordingVideoKeys.set(requestId, videoKey);
}

/** Always removes the entry — call this on success AND failure so keys never leak. */
export function consumeMacroRecordingUploadVideoKey(requestId: string): string | undefined {
  const videoKey = pendingMacroRecordingVideoKeys.get(requestId);
  pendingMacroRecordingVideoKeys.delete(requestId);
  return videoKey;
}

/** Visible to tests — clears pending upload video keys. */
export function clearPendingMacroRecordingUploadVideoKeysForTests(): void {
  pendingMacroRecordingVideoKeys.clear();
}
